import { useState } from "react";
import Sidebar from "../components/Sidebar";
import SidebarRight from "../components/Sidebar-Right";

const howToMenu = [
  { key: "getting-started", label: "Getting Started", icon: <i className="fa fa-play" /> },
  { key: "advanced", label: "Advanced Features", icon: <i className="fa fa-star" /> },
];

const howToContent = {
  "getting-started": (
    <>
      <h2>Getting Started with ISN Network</h2>
      <p>This tutorial will guide you through the basics of getting started with ISN Network.</p>
      <p>Coming soon..</p>
    </>
  ),
  advanced: (
    <>
      <h2>Advanced Features</h2>
      <p>Learn about the advanced features available on ISN Network and how to use them effectively.</p>
      <p>Coming soon..</p>
    </>
  ),
};

const HowTo = () => {
  const [active, setActive] = useState(howToMenu[0].key);

  return (
    <div className="content">
      <Sidebar />
      <div className="main-content">
        <h1>How To</h1>
        <p>
          Welcome to the ISN Network how-to page! Here you will find a collection of
          guides to help you navigate and make the most out of our platform.
        </p>
        {howToContent[active]}
      </div>
      <SidebarRight
        title="Guides"
        menu={howToMenu}
        active={active}
        setActive={setActive}
      />
    </div>
  );
};

export default HowTo;
